export const playlistRequirementsLink =
  'https://help.soundcamps.com/en/articles/4536944-terms-and-conditions-for-curators'

export const termsAndConditions =
  'https://help.soundcamps.com/en/articles/4536944-terms-and-conditions-for-curators'

export const landingPageUrl = 'https://soundcamps.com/'

export const meetConditionsLink =
  'https://help.soundcamps.com/en/articles/5541325-requirements-for-your-playlists'

export const tikTokPromotionLink =
  'https://soundcamps.com/tiktok-music-promotion/'

export const billingPortalLink = 'https://billing.soundcamps.com/'
